import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";

const ContactInfo = () => {
  const items = [
    {
      icon: <FaPhoneAlt />,
      title: "Call Us",
      value: "+91 99266 66609, +91 83195 69994",
    },
    {
      icon: <FaEnvelope />,
      title: "Email Us",
      value: "contact@azconstruction.com",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Visit Us",
      value: "2, Gandhi Gram Colony, Near Khajrana Thana, Dargah Main Road, Khajrana Indore",
    },
    {
      icon: <FaClock />,
      title: "Working Hours",
      value: "Mon - Sat : 9 AM - 7 PM",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container-custom">

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

          {items.map((item, index) => (
            <div
              key={index}
              className="bg-slate-50 p-8 rounded-3xl text-center shadow-sm"
            >
              <div className="w-16 h-16 mx-auto rounded-2xl bg-[#082B57] text-white flex items-center justify-center text-2xl">
                {item.icon}
              </div>

              <h3 className="font-bold text-[#082B57] mt-5">
                {item.title}
              </h3>

              <p className="text-gray-600 mt-3">
                {item.value}
              </p>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ContactInfo;